import React, { useState } from "react";
import { cn } from "@/lib/utils";

type Props = {
  name: string;
  url: string;
  /** Square size in px (default 16, matching the wizard's competitor tags). */
  size?: number;
  className?: string;
};

/** Competitor favicon from DuckDuckGo's icon CDN (a tiny cached image, no backend,
 *  no HTML scraping), with a name-monogram fallback when the site has no icon -
 *  so a miss degrades instead of showing a broken image. Shared so the create
 *  wizard's CompetitorEditor and the detail persona card render competitors
 *  identically. The host is derived from the stored registrable-domain URL. */
/** A safe https link to a competitor's homepage, derived from the stored
 *  registrable-domain URL (which may or may not carry a scheme). */
export function competitorHref(url: string): string {
  const host = url.replace(/^https?:\/\//, "").replace(/\/.*$/, "");
  return `https://${host}`;
}

export function CompetitorFavicon({ name, url, size = 16, className }: Props) {
  const [failed, setFailed] = useState(false);
  const host = url.replace(/^https?:\/\//, "").replace(/\/.*$/, "");
  const initial = (name.trim()[0] || "?").toUpperCase();

  if (failed || !host) {
    return (
      <span
        className={cn("vb-fav vb-fav--mono", className)}
        style={{ width: size, height: size }}
        aria-hidden="true"
      >
        {initial}
      </span>
    );
  }
  return (
    <img
      className={cn("vb-fav vb-fav--icon", className)}
      style={{ width: size, height: size }}
      src={`https://icons.duckduckgo.com/ip3/${host}.ico`}
      alt=""
      aria-hidden="true"
      width={size}
      height={size}
      loading="lazy"
      referrerPolicy="no-referrer"
      onError={() => setFailed(true)}
    />
  );
}

export default CompetitorFavicon;
